// extracted by mini-css-extract-plugin
module.exports = {"heading":"_2UM4-","tabButton":"_2GO2g","active":"gsYn2","slider":"_1TEJO","slide":"_37Vy0","ctaButton":"qKEaE"};